// Automatically generated with Reach 0.1.8 (bf654a17)
/* eslint-disable */
export const _version = '0.1.8';
export const _versionHash = '0.1.8 (bf654a17)';
export const _backendVersion = 10;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Token;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Struct([['rewardToken', ctc1], ['stakeToken', ctc1], ['rewardsPerBlock', ctc2], ['duration', ctc2]]);
  const ctc4 = stdlib.T_Bool;
  const ctc5 = stdlib.T_Null;
  const ctc6 = stdlib.T_Data({
    None: ctc5,
    Some: ctc2
    });
  const map0_ctc = ctc6;
  
  const map1_ctc = ctc6;
  
  
  return {
    infos: {
      end: {
        decode: async (i, svs, args) => {
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
            const [v658, v659, v660, v661, v662, v667, v668, v669] = svs;
            stdlib.assert(false, 'illegal view')
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = svs;
            return (await ((async () => {
              
              
              return v679;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = svs;
            return (await ((async () => {
              
              
              return v679;}))(...args));
            }
          
          stdlib.assert(false, 'illegal view')
          },
        ty: ctc2
        },
      opts: {
        decode: async (i, svs, args) => {
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
            const [v658, v659, v660, v661, v662, v667, v668, v669] = svs;
            return (await ((async () => {
              
              
              return v659;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = svs;
            return (await ((async () => {
              
              
              return v659;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = svs;
            return (await ((async () => {
              
              
              return v659;}))(...args));
            }
          
          stdlib.assert(false, 'illegal view')
          },
        ty: ctc3
        },
      remainingRewards: {
        decode: async (i, svs, args) => {
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
            const [v658, v659, v660, v661, v662, v667, v668, v669] = svs;
            stdlib.assert(false, 'illegal view')
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = svs;
            return (await ((async () => {
              
              
              return v687;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = svs;
            return (await ((async () => {
              
              
              return v687;}))(...args));
            }
          
          stdlib.assert(false, 'illegal view')
          },
        ty: ctc2
        },
      rewardsAvailableAt: {
        decode: async (i, svs, args) => {
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
            const [v658, v659, v660, v661, v662, v667, v668, v669] = svs;
            stdlib.assert(false, 'illegal view')
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = svs;
            return (await ((async (_v1226, _v1227 ) => {
                const v1226 = stdlib.protect(ctc0, _v1226, null);
                const v1227 = stdlib.protect(ctc2, _v1227, null);
              
              const v1228 = stdlib.protect(map0_ctc, await viewlib.viewMapRef(0, v1226), null);
              const v1229 = stdlib.fromSome(v1228, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
              const v1230 = stdlib.protect(map1_ctc, await viewlib.viewMapRef(1, v1226), null);
              const v1231 = stdlib.fromSome(v1230, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
              const v1233 = stdlib.le(v679, v1227);
              const v1234 = v1233 ? v679 : v1227;
              let v1235;
              const v1236 = stdlib.ge(v688, v1234);
              if (v1236) {
                v1235 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
                }
              else {
                const v1237 = stdlib.sub(v1234, v688);
                v1235 = v1237;
                }
              const v1238 = stdlib.mul(v1235, v667);
              const v1239 = stdlib.add(v686, v1238);
              const v1240 = stdlib.le(v1239, v687);
              const v1241 = v1240 ? v1239 : v687;
              const v1243 = stdlib.muldiv(v1241, v1229, v689);
              let v1244;
              const v1245 = stdlib.ge(v1231, v1243);
              if (v1245) {
                v1244 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
                }
              else {
                const v1246 = stdlib.sub(v1243, v1231);
                v1244 = v1246;
                }
              const v1247 = stdlib.le(v1244, v1224);
              const v1248 = v1247 ? v1244 : v1224;
              
              return v1248;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = svs;
            return (await ((async (_v755, _v756 ) => {
                const v755 = stdlib.protect(ctc0, _v755, null);
                const v756 = stdlib.protect(ctc2, _v756, null);
              
              const v757 = stdlib.protect(map0_ctc, await viewlib.viewMapRef(0, v755), null);
              const v758 = stdlib.fromSome(v757, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
              const v759 = stdlib.protect(map1_ctc, await viewlib.viewMapRef(1, v755), null);
              const v760 = stdlib.fromSome(v759, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
              const v762 = stdlib.le(v679, v756);
              const v763 = v762 ? v679 : v756;
              let v764;
              const v765 = stdlib.ge(v688, v763);
              if (v765) {
                v764 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
                }
              else {
                const v766 = stdlib.sub(v763, v688);
                v764 = v766;
                }
              const v767 = stdlib.mul(v764, v667);
              const v768 = stdlib.add(v686, v767);
              const v769 = stdlib.le(v768, v687);
              const v770 = v769 ? v768 : v687;
              const v772 = stdlib.muldiv(v770, v758, v689);
              let v773;
              const v774 = stdlib.ge(v760, v772);
              if (v774) {
                v773 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
                }
              else {
                const v775 = stdlib.sub(v772, v760);
                v773 = v775;
                }
              const v776 = stdlib.le(v773, v753);
              const v777 = v776 ? v773 : v753;
              
              return v777;}))(...args));
            }
          
          stdlib.assert(false, 'illegal view')
          },
        ty: ctc2
        },
      staked: {
        decode: async (i, svs, args) => {
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
            const [v658, v659, v660, v661, v662, v667, v668, v669] = svs;
            stdlib.assert(false, 'illegal view')
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = svs;
            return (await ((async (_v680 ) => {
                const v680 = stdlib.protect(ctc0, _v680, null);
              
              const v681 = stdlib.protect(map0_ctc, await viewlib.viewMapRef(0, v680), null);
              const v682 = stdlib.fromSome(v681, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
              
              return v682;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = svs;
            return (await ((async (_v680 ) => {
                const v680 = stdlib.protect(ctc0, _v680, null);
              
              const v681 = stdlib.protect(map0_ctc, await viewlib.viewMapRef(0, v680), null);
              const v682 = stdlib.fromSome(v681, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
              
              return v682;}))(...args));
            }
          
          stdlib.assert(false, 'illegal view')
          },
        ty: ctc2
        },
      totalStaked: {
        decode: async (i, svs, args) => {
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
            const [v658, v659, v660, v661, v662, v667, v668, v669] = svs;
            stdlib.assert(false, 'illegal view')
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = svs;
            return (await ((async () => {
              
              
              return v689;}))(...args));
            }
          if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6))) {
            const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = svs;
            return (await ((async () => {
              
              
              return v689;}))(...args));
            }
          
          stdlib.assert(false, 'illegal view')
          },
        ty: ctc2
        }
      },
    views: {
      1: [ctc0, ctc3, ctc1, ctc1, ctc2, ctc2, ctc2, ctc2],
      3: [ctc0, ctc3, ctc1, ctc1, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2],
      6: [ctc0, ctc3, ctc1, ctc1, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc4, ctc2]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Tuple([ctc2, ctc2]);
  return {
    mapDataTy: ctc3
    };
  };
export async function Any_halt(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Any_halt expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Any_halt expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Address;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Struct([['rewardToken', ctc4], ['stakeToken', ctc4], ['rewardsPerBlock', ctc1], ['duration', ctc1]]);
  const ctc6 = stdlib.T_Tuple([]);
  const ctc7 = stdlib.T_Data({
    Any_halt0_555: ctc6,
    Deployer0_555: ctc0
    });
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true,
    ty: map0_ctc
    });
  
  const map1_ctc = ctc2;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true,
    ty: map1_ctc
    });
  
  
  const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3), [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1257 = stdlib.protect(ctc6, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:196:9:application call to [unknown function] (defined at: ./index.rsh:196:9:function exp)', 'at ./index.rsh:194:7:application call to "runAny_halt0_555" (defined at: ./index.rsh:196:9:function exp)', 'at ./index.rsh:194:7:application call to [unknown function] (defined at: ./index.rsh:194:7:function exp)'],
    msg: 'in',
    who: 'Any_halt'
    });
  const v1260 = ['Any_halt0_555', v1257];
  
  const txn1 = await (ctc.sendrecv({
    args: [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224, v1260],
    evt_cnt: 1,
    funcNum: 3,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc7],
    pay: [stdlib.checkedBigNumberify('./index.rsh:196:9:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [v1265], secs: v1267, time: v1266, didSend: v608, from: v1264 } = txn1;
      
      switch (v1265[0]) {
        case 'Any_halt0_555': {
          const v1268 = v1265[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./index.rsh:196:9:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v1276 = null;
          const v1277 = await txn1.getOutput('Any_halt', 'v1276', ctc0, v1276);
          
          sim_r.txns.push({
            amt: v697,
            kind: 'from',
            to: v658,
            tok: v660
            });
          sim_r.txns.push({
            amt: v698,
            kind: 'from',
            to: v658,
            tok: v661
            });
          sim_r.txns.push({
            amt: v696,
            kind: 'from',
            to: v658,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v661
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v660
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          
          break;
          }
        case 'Deployer0_555': {
          const v1326 = v1265[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc7],
    waitIfNotPresent: false
    }));
  const {data: [v1265], secs: v1267, time: v1266, didSend: v608, from: v1264 } = txn1;
  switch (v1265[0]) {
    case 'Any_halt0_555': {
      const v1268 = v1265[1];
      ;
      undefined;
      const v1276 = null;
      const v1277 = await txn1.getOutput('Any_halt', 'v1276', ctc0, v1276);
      if (v608) {
        stdlib.protect(ctc0, await interact.out(v1268, v1277), {
          at: './index.rsh:196:10:application',
          fs: ['at ./index.rsh:196:10:application call to [unknown function] (defined at: ./index.rsh:196:10:function exp)', 'at ./index.rsh:196:30:application call to "k" (defined at: ./index.rsh:196:24:function exp)'],
          msg: 'out',
          who: 'Any_halt'
          });
        }
      else {
        }
      
      ;
      ;
      ;
      return;
      
      break;
      }
    case 'Deployer0_555': {
      const v1326 = v1265[1];
      return;
      break;
      }
    }
  
  
  };
export async function Deployer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Deployer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Deployer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Token;
  const ctc4 = stdlib.T_Struct([['rewardToken', ctc3], ['stakeToken', ctc3], ['rewardsPerBlock', ctc1], ['duration', ctc1]]);
  const ctc5 = stdlib.T_Tuple([]);
  const ctc6 = stdlib.T_Tuple([ctc1]);
  const ctc7 = stdlib.T_Data({
    Staker_harvest0_239: ctc5,
    Staker_stake0_239: ctc6,
    Staker_withdraw0_239: ctc6
    });
  const ctc8 = stdlib.T_Struct([['userReceived', ctc1], ['totalRemaining', ctc1]]);
  const ctc9 = stdlib.T_Struct([['newUserStaked', ctc1], ['newEveryoneStaked', ctc1]]);
  const ctc10 = stdlib.T_Data({
    Any_halt0_555: ctc5,
    Deployer0_555: ctc0
    });
  const ctc11 = stdlib.T_Address;
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: false,
    ty: map0_ctc
    });
  
  const map1_ctc = ctc2;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: false,
    ty: map1_ctc
    });
  
  
  const v651 = stdlib.protect(ctc4, interact.opts, 'for Deployer\'s interact field opts');
  
  const v654 = v651.rewardToken;
  const v655 = v651.stakeToken;
  const v656 = stdlib.tokenEq(v654, v655);
  const v657 = v656 ? false : true;
  stdlib.assert(v657, {
    at: './index.rsh:60:11:application',
    fs: ['at ./index.rsh:57:16:application call to [unknown function] (defined at: ./index.rsh:57:20:function exp)'],
    msg: null,
    who: 'Deployer'
    });
  
  const txn1 = await (ctc.sendrecv({
    args: [v651, v654, v655],
    evt_cnt: 3,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./index.rsh:62:12:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc4, ctc3, ctc3],
    pay: [stdlib.checkedBigNumberify('./index.rsh:62:12:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [v659, v660, v661], secs: v663, time: v662, didSend: v37, from: v658 } = txn1;
      
      const v664 = stdlib.tokenEq(v660, v661);
      const v665 = v664 ? false : true;
      stdlib.assert(v665, {
        at: './index.rsh:62:12:dot',
        fs: [],
        msg: 'non-network tokens distinct',
        who: 'Deployer'
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v660
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v661
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:62:12:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v667 = v659.rewardsPerBlock;
      const v668 = v659.duration;
      const v669 = stdlib.mul(v667, v668);
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc4, ctc3, ctc3],
    waitIfNotPresent: false
    }));
  const {data: [v659, v660, v661], secs: v663, time: v662, didSend: v37, from: v658 } = txn1;
  const v664 = stdlib.tokenEq(v660, v661);
  const v665 = v664 ? false : true;
  stdlib.assert(v665, {
    at: './index.rsh:62:12:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Deployer'
    });
  ;
  ;
  ;
  const v667 = v659.rewardsPerBlock;
  const v668 = v659.duration;
  const v669 = stdlib.mul(v667, v668);
  const txn2 = await (ctc.sendrecv({
    args: [v658, v659, v660, v661, v662, v667, v668, v669],
    evt_cnt: 0,
    funcNum: 1,
    lct: v662,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./index.rsh:68:12:dot', stdlib.UInt_max, 0), [[v669, v660]]],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [], secs: v672, time: v671, didSend: v48, from: v670 } = txn2;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./index.rsh:68:12:dot', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      sim_r.txns.push({
        amt: v669,
        kind: 'to',
        tok: v660
        });
      const v676 = stdlib.addressEq(v658, v670);
      stdlib.assert(v676, {
        at: './index.rsh:68:12:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Deployer'
        });
      const v678 = stdlib.add(v662, stdlib.checkedBigNumberify('./index.rsh:73:39:decimal', stdlib.UInt_max, 2));
      const v679 = stdlib.add(v678, v668);
      
      const v686 = stdlib.checkedBigNumberify('./index.rsh:90:83:decimal', stdlib.UInt_max, 0);
      const v687 = v669;
      const v688 = v678;
      const v689 = stdlib.checkedBigNumberify('./index.rsh:90:21:decimal', stdlib.UInt_max, 0);
      const v690 = v671;
      const v691 = v662;
      const v696 = stdlib.checkedBigNumberify('./index.rsh:55:9:after expr stmt semicolon', stdlib.UInt_max, 0);
      const v697 = v669;
      const v698 = stdlib.checkedBigNumberify('./index.rsh:62:12:dot', stdlib.UInt_max, 0);
      
      if (await (async () => {
        const v740 = stdlib.eq(v689, stdlib.checkedBigNumberify('./index.rsh:140:27:decimal', stdlib.UInt_max, 0));
        const v742 = stdlib.le(v691, v679);
        const v743 = v740 ? v742 : true;
        
        return v743;})()) {
        const v745 = stdlib.le(v679, v691);
        const v746 = v745 ? v679 : v691;
        let v747;
        const v748 = stdlib.ge(v688, v746);
        if (v748) {
          v747 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v749 = stdlib.sub(v746, v688);
          v747 = v749;
          }
        const v750 = stdlib.mul(v747, v667);
        const v751 = stdlib.add(v686, v750);
        const v752 = stdlib.le(v751, v687);
        const v753 = v752 ? v751 : v687;
        sim_r.isHalt = false;
        }
      else {
        const v1216 = stdlib.le(v679, v691);
        const v1217 = v1216 ? v679 : v691;
        let v1218;
        const v1219 = stdlib.ge(v688, v1217);
        if (v1219) {
          v1218 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v1220 = stdlib.sub(v1217, v688);
          v1218 = v1220;
          }
        const v1221 = stdlib.mul(v1218, v667);
        const v1222 = stdlib.add(v686, v1221);
        const v1223 = stdlib.le(v1222, v687);
        const v1224 = v1223 ? v1222 : v687;
        sim_r.isHalt = false;
        }
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc11, ctc4, ctc3, ctc3, ctc1, ctc1, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v672, time: v671, didSend: v48, from: v670 } = txn2;
  ;
  ;
  const v676 = stdlib.addressEq(v658, v670);
  stdlib.assert(v676, {
    at: './index.rsh:68:12:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Deployer'
    });
  const v678 = stdlib.add(v662, stdlib.checkedBigNumberify('./index.rsh:73:39:decimal', stdlib.UInt_max, 2));
  const v679 = stdlib.add(v678, v668);
  stdlib.protect(ctc0, await interact.readyForStakers(), {
    at: './index.rsh:1:39:application',
    fs: ['at ./index.rsh:1:21:application call to [unknown function] (defined at: ./index.rsh:1:25:function exp)', 'at ./index.rsh:88:36:application call to "liftedInteract" (defined at: ./index.rsh:88:36:application)'],
    msg: 'readyForStakers',
    who: 'Deployer'
    });
  
  let v686 = stdlib.checkedBigNumberify('./index.rsh:90:83:decimal', stdlib.UInt_max, 0);
  let v687 = v669;
  let v688 = v678;
  let v689 = stdlib.checkedBigNumberify('./index.rsh:90:21:decimal', stdlib.UInt_max, 0);
  let v690 = v671;
  let v691 = v662;
  let v696 = stdlib.checkedBigNumberify('./index.rsh:55:9:after expr stmt semicolon', stdlib.UInt_max, 0);
  let v697 = v669;
  let v698 = stdlib.checkedBigNumberify('./index.rsh:62:12:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    const v740 = stdlib.eq(v689, stdlib.checkedBigNumberify('./index.rsh:140:27:decimal', stdlib.UInt_max, 0));
    const v742 = stdlib.le(v691, v679);
    const v743 = v740 ? v742 : true;
    
    return v743;})()) {
    const v745 = stdlib.le(v679, v691);
    const v746 = v745 ? v679 : v691;
    let v747;
    const v748 = stdlib.ge(v688, v746);
    if (v748) {
      v747 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
      }
    else {
      const v749 = stdlib.sub(v746, v688);
      v747 = v749;
      }
    const v750 = stdlib.mul(v747, v667);
    const v751 = stdlib.add(v686, v750);
    const v752 = stdlib.le(v751, v687);
    const v753 = v752 ? v751 : v687;
    const txn3 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 4,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn3;
    switch (v837[0]) {
      case 'Staker_harvest0_239': {
        const v840 = v837[1];
        ;
        ;
        undefined;
        const v879 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v836), null);
        const v880 = stdlib.fromSome(v879, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
        const v881 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, v836), null);
        const v882 = stdlib.fromSome(v881, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
        let v886;
        if (v748) {
          v886 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v888 = stdlib.sub(v746, v688);
          v886 = v888;
          }
        const v889 = stdlib.mul(v886, v667);
        const v890 = stdlib.add(v686, v889);
        const v891 = stdlib.le(v890, v687);
        const v892 = v891 ? v890 : v687;
        const v894 = stdlib.muldiv(v892, v880, v689);
        let v895;
        const v896 = stdlib.ge(v882, v894);
        if (v896) {
          v895 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v897 = stdlib.sub(v894, v882);
          v895 = v897;
          }
        const v898 = stdlib.le(v895, v753);
        const v899 = v898 ? v895 : v753;
        const v905 = stdlib.sub(v697, v899);
        ;
        const v906 = stdlib.sub(v687, v899);
        const v909 = stdlib.add(v882, v899);
        await stdlib.mapSet(map1, v836, v909);
        const v910 = {
          totalRemaining: v906,
          userReceived: v899
          };
        await txn3.getOutput('Staker_harvest', 'v910', ctc8, v910);
        const v916 = stdlib.sub(v753, v899);
        const cv686 = v916;
        const cv687 = v906;
        const cv688 = v691;
        const cv689 = v689;
        const cv690 = v838;
        const cv691 = v690;
        const cv696 = v696;
        const cv697 = v905;
        const cv698 = v698;
        
        v686 = cv686;
        v687 = cv687;
        v688 = cv688;
        v689 = cv689;
        v690 = cv690;
        v691 = cv691;
        v696 = cv696;
        v697 = cv697;
        v698 = cv698;
        
        continue;
        break;
        }
      case 'Staker_stake0_239': {
        const v965 = v837[1];
        const v977 = v965[stdlib.checkedBigNumberify('./index.rsh:141:9:spread', stdlib.UInt_max, 0)];
        ;
        const v1002 = stdlib.add(v698, v977);
        ;
        undefined;
        const v1045 = stdlib.add(v689, v977);
        const v1046 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v836), null);
        const v1047 = stdlib.fromSome(v1046, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
        const v1048 = stdlib.add(v1047, v977);
        await stdlib.mapSet(map0, v836, v1048);
        const v1049 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, v836), null);
        const v1050 = stdlib.fromSome(v1049, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
        const v1051 = stdlib.mul(v753, v977);
        const v1052 = stdlib.div(v1051, v1045);
        const v1053 = stdlib.add(v1050, v1052);
        await stdlib.mapSet(map1, v836, v1053);
        const v1054 = {
          newEveryoneStaked: v1045,
          newUserStaked: v1048
          };
        await txn3.getOutput('Staker_stake', 'v1054', ctc9, v1054);
        const cv686 = v753;
        const cv687 = v687;
        const cv688 = v691;
        const cv689 = v1045;
        const cv690 = v838;
        const cv691 = v690;
        const cv696 = v696;
        const cv697 = v697;
        const cv698 = v1002;
        
        v686 = cv686;
        v687 = cv687;
        v688 = cv688;
        v689 = cv689;
        v690 = cv690;
        v691 = cv691;
        v696 = cv696;
        v697 = cv697;
        v698 = cv698;
        
        continue;
        break;
        }
      case 'Staker_withdraw0_239': {
        const v1090 = v837[1];
        ;
        ;
        undefined;
        const v1187 = v1090[stdlib.checkedBigNumberify('./index.rsh:153:9:spread', stdlib.UInt_max, 0)];
        const v1188 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v836), null);
        const v1189 = stdlib.fromSome(v1188, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
        const v1191 = stdlib.le(v1187, v1189);
        stdlib.assert(v1191, {
          at: './index.rsh:159:16:application',
          fs: ['at ./index.rsh:156:7:application call to [unknown function] (defined at: ./index.rsh:156:7:function exp)'],
          msg: null,
          who: 'Deployer'
          });
        const v1195 = stdlib.sub(v698, v1187);
        ;
        const v1196 = stdlib.sub(v689, v1187);
        const v1197 = stdlib.sub(v1189, v1187);
        await stdlib.mapSet(map0, v836, v1197);
        const v1198 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, v836), null);
        const v1199 = stdlib.fromSome(v1198, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
        let v1200;
        const v1201 = stdlib.eq(v1196, stdlib.checkedBigNumberify('./index.rsh:167:36:decimal', stdlib.UInt_max, 0));
        if (v1201) {
          v1200 = v753;
          }
        else {
          const v1202 = stdlib.mul(v753, v1187);
          const v1203 = stdlib.div(v1202, v1196);
          v1200 = v1203;
          }
        let v1204;
        const v1205 = stdlib.ge(v1200, v1199);
        if (v1205) {
          v1204 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v1206 = stdlib.sub(v1199, v1200);
          v1204 = v1206;
          }
        await stdlib.mapSet(map1, v836, v1204);
        const v1208 = {
          newEveryoneStaked: v1196,
          newUserStaked: v1197
          };
        await txn3.getOutput('Staker_withdraw', 'v1208', ctc9, v1208);
        const cv686 = v753;
        const cv687 = v687;
        const cv688 = v691;
        const cv689 = v1196;
        const cv690 = v838;
        const cv691 = v690;
        const cv696 = v696;
        const cv697 = v697;
        const cv698 = v1195;
        
        v686 = cv686;
        v687 = cv687;
        v688 = cv688;
        v689 = cv689;
        v690 = cv690;
        v691 = cv691;
        v696 = cv696;
        v697 = cv697;
        v698 = cv698;
        
        continue;
        break;
        }
      }
    
    }
  const v1216 = stdlib.le(v679, v691);
  const v1217 = v1216 ? v679 : v691;
  let v1218;
  const v1219 = stdlib.ge(v688, v1217);
  if (v1219) {
    v1218 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
    }
  else {
    const v1220 = stdlib.sub(v1217, v688);
    v1218 = v1220;
    }
  const v1221 = stdlib.mul(v1218, v667);
  const v1222 = stdlib.add(v686, v1221);
  const v1223 = stdlib.le(v1222, v687);
  const v1224 = v1223 ? v1222 : v687;
  const v1253 = ['Deployer0_555', null];
  
  const txn3 = await (ctc.sendrecv({
    args: [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v696, v697, v698, v1224, v1253],
    evt_cnt: 1,
    funcNum: 3,
    lct: v690,
    onlyIf: true,
    out_tys: [ctc10],
    pay: [stdlib.checkedBigNumberify('./index.rsh:195:39:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [v1265], secs: v1267, time: v1266, didSend: v608, from: v1264 } = txn3;
      
      switch (v1265[0]) {
        case 'Any_halt0_555': {
          const v1268 = v1265[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./index.rsh:196:9:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v1276 = null;
          await txn3.getOutput('Any_halt', 'v1276', ctc0, v1276);
          sim_r.txns.push({
            amt: v697,
            kind: 'from',
            to: v658,
            tok: v660
            });
          sim_r.txns.push({
            amt: v698,
            kind: 'from',
            to: v658,
            tok: v661
            });
          sim_r.txns.push({
            amt: v696,
            kind: 'from',
            to: v658,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v661
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v660
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          
          break;
          }
        case 'Deployer0_555': {
          const v1326 = v1265[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./index.rsh:196:9:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1362 = stdlib.addressEq(v1264, v658);
          stdlib.assert(v1362, {
            at: './index.rsh:194:7:application',
            fs: [],
            msg: null,
            who: 'Deployer'
            });
          sim_r.txns.push({
            amt: v697,
            kind: 'from',
            to: v658,
            tok: v660
            });
          sim_r.txns.push({
            amt: v698,
            kind: 'from',
            to: v658,
            tok: v661
            });
          sim_r.txns.push({
            amt: v696,
            kind: 'from',
            to: v658,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v661
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v660
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc11, ctc4, ctc3, ctc3, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc10],
    waitIfNotPresent: false
    }));
  const {data: [v1265], secs: v1267, time: v1266, didSend: v608, from: v1264 } = txn3;
  switch (v1265[0]) {
    case 'Any_halt0_555': {
      const v1268 = v1265[1];
      ;
      undefined;
      const v1276 = null;
      await txn3.getOutput('Any_halt', 'v1276', ctc0, v1276);
      ;
      ;
      ;
      return;
      
      break;
      }
    case 'Deployer0_555': {
      const v1326 = v1265[1];
      ;
      const v1362 = stdlib.addressEq(v1264, v658);
      stdlib.assert(v1362, {
        at: './index.rsh:194:7:application',
        fs: [],
        msg: null,
        who: 'Deployer'
        });
      ;
      ;
      ;
      return;
      
      break;
      }
    }
  
  
  
  
  
  };
export async function Staker_harvest(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Staker_harvest expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Staker_harvest expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Address;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Struct([['rewardToken', ctc4], ['stakeToken', ctc4], ['rewardsPerBlock', ctc1], ['duration', ctc1]]);
  const ctc6 = stdlib.T_Bool;
  const ctc7 = stdlib.T_Tuple([]);
  const ctc8 = stdlib.T_Tuple([ctc1]);
  const ctc9 = stdlib.T_Data({
    Staker_harvest0_239: ctc7,
    Staker_stake0_239: ctc8,
    Staker_withdraw0_239: ctc8
    });
  const ctc10 = stdlib.T_Struct([['userReceived', ctc1], ['totalRemaining', ctc1]]);
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true,
    ty: map0_ctc
    });
  
  const map1_ctc = ctc2;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true,
    ty: map1_ctc
    });
  
  
  const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6), [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6, ctc1]);
  const v799 = stdlib.protect(ctc7, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:182:9:application call to [unknown function] (defined at: ./index.rsh:182:9:function exp)', 'at ./index.rsh:90:19:application call to "runStaker_harvest0_239" (defined at: ./index.rsh:182:9:function exp)', 'at ./index.rsh:90:19:application call to [unknown function] (defined at: ./index.rsh:90:19:function exp)'],
    msg: 'in',
    who: 'Staker_harvest'
    });
  const v802 = ['Staker_harvest0_239', v799];
  
  const txn1 = await (ctc.sendrecv({
    args: [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753, v802],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc9],
    pay: [stdlib.checkedBigNumberify('./index.rsh:183:15:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./index.rsh:183:19:decimal', stdlib.UInt_max, 0), v661]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn1;
      
      switch (v837[0]) {
        case 'Staker_harvest0_239': {
          const v840 = v837[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v661
            });
          undefined;
          const v879 = stdlib.protect(map0_ctc, await stdlib.simMapRef(sim_r, 0, v836), null);
          const v880 = stdlib.fromSome(v879, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
          const v881 = stdlib.protect(map1_ctc, await stdlib.simMapRef(sim_r, 1, v836), null);
          const v882 = stdlib.fromSome(v881, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
          let v886;
          if (v748) {
            v886 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
            }
          else {
            const v888 = stdlib.sub(v746, v688);
            v886 = v888;
            }
          const v889 = stdlib.mul(v886, v667);
          const v890 = stdlib.add(v686, v889);
          const v891 = stdlib.le(v890, v687);
          const v892 = v891 ? v890 : v687;
          const v894 = stdlib.muldiv(v892, v880, v689);
          let v895;
          const v896 = stdlib.ge(v882, v894);
          if (v896) {
            v895 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
            }
          else {
            const v897 = stdlib.sub(v894, v882);
            v895 = v897;
            }
          const v898 = stdlib.le(v895, v753);
          const v899 = v898 ? v895 : v753;
          const v905 = stdlib.sub(v697, v899);
          sim_r.txns.push({
            amt: v899,
            kind: 'from',
            to: v836,
            tok: v660
            });
          const v906 = stdlib.sub(v687, v899);
          const v909 = stdlib.add(v882, v899);
          await stdlib.simMapSet(sim_r, 1, v836, v909);
          const v910 = {
            totalRemaining: v906,
            userReceived: v899
            };
          const v911 = await txn1.getOutput('Staker_harvest', 'v910', ctc10, v910);
          
          const v916 = stdlib.sub(v753, v899);
          const v2620 = v916;
          const v2621 = v906;
          const v2622 = v691;
          const v2623 = v689;
          const v2624 = v838;
          const v2625 = v690;
          const v2626 = v696;
          const v2627 = v905;
          const v2628 = v698;
          const v2629 = stdlib.eq(v689, stdlib.checkedBigNumberify('./index.rsh:140:27:decimal', stdlib.UInt_max, 0));
          const v2630 = stdlib.le(v690, v679);
          const v2631 = v2629 ? v2630 : true;
          if (v2631) {
            const v2632 = stdlib.le(v679, v690);
            const v2633 = v2632 ? v679 : v690;
            let v2634;
            const v2635 = stdlib.ge(v691, v2633);
            if (v2635) {
              v2634 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
              }
            else {
              const v2636 = stdlib.sub(v2633, v691);
              v2634 = v2636;
              }
            const v2637 = stdlib.mul(v2634, v667);
            const v2638 = stdlib.add(v916, v2637);
            const v2639 = stdlib.le(v2638, v906);
            const v2640 = v2639 ? v2638 : v906;
            sim_r.isHalt = false;
            }
          else {
            const v2641 = stdlib.le(v679, v690);
            const v2642 = v2641 ? v679 : v690;
            let v2643;
            const v2644 = stdlib.ge(v691, v2642);
            if (v2644) {
              v2643 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
              }
            else {
              const v2645 = stdlib.sub(v2642, v691);
              v2643 = v2645;
              }
            const v2646 = stdlib.mul(v2643, v667);
            const v2647 = stdlib.add(v916, v2646);
            const v2648 = stdlib.le(v2647, v906);
            const v2649 = v2648 ? v2647 : v906;
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Staker_stake0_239': {
          const v965 = v837[1];
          
          break;
          }
        case 'Staker_withdraw0_239': {
          const v1090 = v837[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6, ctc1, ctc9],
    waitIfNotPresent: false
    }));
  const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn1;
  switch (v837[0]) {
    case 'Staker_harvest0_239': {
      const v840 = v837[1];
      ;
      ;
      undefined;
      const v879 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v836), null);
      const v880 = stdlib.fromSome(v879, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
      const v881 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, v836), null);
      const v882 = stdlib.fromSome(v881, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
      let v886;
      if (v748) {
        v886 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
        }
      else {
        const v888 = stdlib.sub(v746, v688);
        v886 = v888;
        }
      const v889 = stdlib.mul(v886, v667);
      const v890 = stdlib.add(v686, v889);
      const v891 = stdlib.le(v890, v687);
      const v892 = v891 ? v890 : v687;
      const v894 = stdlib.muldiv(v892, v880, v689);
      let v895;
      const v896 = stdlib.ge(v882, v894);
      if (v896) {
        v895 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
        }
      else {
        const v897 = stdlib.sub(v894, v882);
        v895 = v897;
        }
      const v898 = stdlib.le(v895, v753);
      const v899 = v898 ? v895 : v753;
      const v905 = stdlib.sub(v697, v899);
      ;
      const v906 = stdlib.sub(v687, v899);
      const v909 = stdlib.add(v882, v899);
      await stdlib.mapSet(map1, v836, v909);
      const v910 = {
        totalRemaining: v906,
        userReceived: v899
        };
      const v911 = await txn1.getOutput('Staker_harvest', 'v910', ctc10, v910);
      if (v402) {
        stdlib.protect(ctc0, await interact.out(v840, v911), {
          at: './index.rsh:182:10:application',
          fs: ['at ./index.rsh:182:10:application call to [unknown function] (defined at: ./index.rsh:182:10:function exp)', 'at ./index.rsh:190:10:application call to "k" (defined at: ./index.rsh:184:7:function exp)', 'at ./index.rsh:184:7:application call to [unknown function] (defined at: ./index.rsh:184:7:function exp)'],
          msg: 'out',
          who: 'Staker_harvest'
          });
        }
      else {
        }
      
      const v916 = stdlib.sub(v753, v899);
      const v2620 = v916;
      const v2621 = v906;
      const v2622 = v691;
      const v2623 = v689;
      const v2624 = v838;
      const v2625 = v690;
      const v2626 = v696;
      const v2627 = v905;
      const v2628 = v698;
      const v2629 = stdlib.eq(v689, stdlib.checkedBigNumberify('./index.rsh:140:27:decimal', stdlib.UInt_max, 0));
      const v2630 = stdlib.le(v690, v679);
      const v2631 = v2629 ? v2630 : true;
      if (v2631) {
        const v2632 = stdlib.le(v679, v690);
        const v2633 = v2632 ? v679 : v690;
        let v2634;
        const v2635 = stdlib.ge(v691, v2633);
        if (v2635) {
          v2634 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v2636 = stdlib.sub(v2633, v691);
          v2634 = v2636;
          }
        const v2637 = stdlib.mul(v2634, v667);
        const v2638 = stdlib.add(v916, v2637);
        const v2639 = stdlib.le(v2638, v906);
        const v2640 = v2639 ? v2638 : v906;
        return;
        }
      else {
        const v2641 = stdlib.le(v679, v690);
        const v2642 = v2641 ? v679 : v690;
        let v2643;
        const v2644 = stdlib.ge(v691, v2642);
        if (v2644) {
          v2643 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v2645 = stdlib.sub(v2642, v691);
          v2643 = v2645;
          }
        const v2646 = stdlib.mul(v2643, v667);
        const v2647 = stdlib.add(v916, v2646);
        const v2648 = stdlib.le(v2647, v906);
        const v2649 = v2648 ? v2647 : v906;
        return;
        }
      break;
      }
    case 'Staker_stake0_239': {
      const v965 = v837[1];
      return;
      break;
      }
    case 'Staker_withdraw0_239': {
      const v1090 = v837[1];
      return;
      break;
      }
    }
  
  
  };
export async function Staker_stake(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Staker_stake expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Staker_stake expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Address;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Struct([['rewardToken', ctc4], ['stakeToken', ctc4], ['rewardsPerBlock', ctc1], ['duration', ctc1]]);
  const ctc6 = stdlib.T_Bool;
  const ctc7 = stdlib.T_Tuple([ctc1]);
  const ctc8 = stdlib.T_Tuple([]);
  const ctc9 = stdlib.T_Data({
    Staker_harvest0_239: ctc8,
    Staker_stake0_239: ctc7,
    Staker_withdraw0_239: ctc7
    });
  const ctc10 = stdlib.T_Struct([['newUserStaked', ctc1], ['newEveryoneStaked', ctc1]]);
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true,
    ty: map0_ctc
    });
  
  const map1_ctc = ctc2;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true,
    ty: map1_ctc
    });
  
  
  const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6), [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6, ctc1]);
  const v781 = stdlib.protect(ctc7, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:141:9:application call to [unknown function] (defined at: ./index.rsh:141:9:function exp)', 'at ./index.rsh:90:19:application call to "runStaker_stake0_239" (defined at: ./index.rsh:141:9:function exp)', 'at ./index.rsh:90:19:application call to [unknown function] (defined at: ./index.rsh:90:19:function exp)'],
    msg: 'in',
    who: 'Staker_stake'
    });
  const v782 = v781[stdlib.checkedBigNumberify('./index.rsh:141:9:spread', stdlib.UInt_max, 0)];
  const v785 = ['Staker_stake0_239', v781];
  
  const txn1 = await (ctc.sendrecv({
    args: [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753, v785],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc9],
    pay: [stdlib.checkedBigNumberify('./index.rsh:142:18:decimal', stdlib.UInt_max, 0), [[v782, v661]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn1;
      
      switch (v837[0]) {
        case 'Staker_harvest0_239': {
          const v840 = v837[1];
          
          break;
          }
        case 'Staker_stake0_239': {
          const v965 = v837[1];
          const v977 = v965[stdlib.checkedBigNumberify('./index.rsh:141:9:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1002 = stdlib.add(v698, v977);
          sim_r.txns.push({
            amt: v977,
            kind: 'to',
            tok: v661
            });
          undefined;
          const v1045 = stdlib.add(v689, v977);
          const v1046 = stdlib.protect(map0_ctc, await stdlib.simMapRef(sim_r, 0, v836), null);
          const v1047 = stdlib.fromSome(v1046, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
          const v1048 = stdlib.add(v1047, v977);
          await stdlib.simMapSet(sim_r, 0, v836, v1048);
          const v1049 = stdlib.protect(map1_ctc, await stdlib.simMapRef(sim_r, 1, v836), null);
          const v1050 = stdlib.fromSome(v1049, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
          const v1051 = stdlib.mul(v753, v977);
          const v1052 = stdlib.div(v1051, v1045);
          const v1053 = stdlib.add(v1050, v1052);
          await stdlib.simMapSet(sim_r, 1, v836, v1053);
          const v1054 = {
            newEveryoneStaked: v1045,
            newUserStaked: v1048
            };
          const v1055 = await txn1.getOutput('Staker_stake', 'v1054', ctc10, v1054);
          
          const v2780 = v753;
          const v2781 = v687;
          const v2782 = v691;
          const v2783 = v1045;
          const v2784 = v838;
          const v2785 = v690;
          const v2786 = v696;
          const v2787 = v697;
          const v2788 = v1002;
          const v2789 = stdlib.eq(v1045, stdlib.checkedBigNumberify('./index.rsh:140:27:decimal', stdlib.UInt_max, 0));
          const v2790 = stdlib.le(v690, v679);
          const v2791 = v2789 ? v2790 : true;
          if (v2791) {
            const v2792 = stdlib.le(v679, v690);
            const v2793 = v2792 ? v679 : v690;
            let v2794;
            const v2795 = stdlib.ge(v691, v2793);
            if (v2795) {
              v2794 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
              }
            else {
              const v2796 = stdlib.sub(v2793, v691);
              v2794 = v2796;
              }
            const v2797 = stdlib.mul(v2794, v667);
            const v2798 = stdlib.add(v753, v2797);
            const v2799 = stdlib.le(v2798, v687);
            const v2800 = v2799 ? v2798 : v687;
            sim_r.isHalt = false;
            }
          else {
            const v2801 = stdlib.le(v679, v690);
            const v2802 = v2801 ? v679 : v690;
            let v2803;
            const v2804 = stdlib.ge(v691, v2802);
            if (v2804) {
              v2803 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
              }
            else {
              const v2805 = stdlib.sub(v2802, v691);
              v2803 = v2805;
              }
            const v2806 = stdlib.mul(v2803, v667);
            const v2807 = stdlib.add(v753, v2806);
            const v2808 = stdlib.le(v2807, v687);
            const v2809 = v2808 ? v2807 : v687;
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Staker_withdraw0_239': {
          const v1090 = v837[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6, ctc1, ctc9],
    waitIfNotPresent: false
    }));
  const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn1;
  switch (v837[0]) {
    case 'Staker_harvest0_239': {
      const v840 = v837[1];
      return;
      break;
      }
    case 'Staker_stake0_239': {
      const v965 = v837[1];
      const v977 = v965[stdlib.checkedBigNumberify('./index.rsh:141:9:spread', stdlib.UInt_max, 0)];
      ;
      const v1002 = stdlib.add(v698, v977);
      ;
      undefined;
      const v1045 = stdlib.add(v689, v977);
      const v1046 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v836), null);
      const v1047 = stdlib.fromSome(v1046, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
      const v1048 = stdlib.add(v1047, v977);
      await stdlib.mapSet(map0, v836, v1048);
      const v1049 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, v836), null);
      const v1050 = stdlib.fromSome(v1049, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
      const v1051 = stdlib.mul(v753, v977);
      const v1052 = stdlib.div(v1051, v1045);
      const v1053 = stdlib.add(v1050, v1052);
      await stdlib.mapSet(map1, v836, v1053);
      const v1054 = {
        newEveryoneStaked: v1045,
        newUserStaked: v1048
        };
      const v1055 = await txn1.getOutput('Staker_stake', 'v1054', ctc10, v1054);
      if (v402) {
        stdlib.protect(ctc0, await interact.out(v965, v1055), {
          at: './index.rsh:141:10:application',
          fs: ['at ./index.rsh:141:10:application call to [unknown function] (defined at: ./index.rsh:141:10:function exp)', 'at ./index.rsh:150:10:application call to "k" (defined at: ./index.rsh:143:7:function exp)', 'at ./index.rsh:143:7:application call to [unknown function] (defined at: ./index.rsh:143:7:function exp)'],
          msg: 'out',
          who: 'Staker_stake'
          });
        }
      else {
        }
      
      const v2780 = v753;
      const v2781 = v687;
      const v2782 = v691;
      const v2783 = v1045;
      const v2784 = v838;
      const v2785 = v690;
      const v2786 = v696;
      const v2787 = v697;
      const v2788 = v1002;
      const v2789 = stdlib.eq(v1045, stdlib.checkedBigNumberify('./index.rsh:140:27:decimal', stdlib.UInt_max, 0));
      const v2790 = stdlib.le(v690, v679);
      const v2791 = v2789 ? v2790 : true;
      if (v2791) {
        const v2792 = stdlib.le(v679, v690);
        const v2793 = v2792 ? v679 : v690;
        let v2794;
        const v2795 = stdlib.ge(v691, v2793);
        if (v2795) {
          v2794 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v2796 = stdlib.sub(v2793, v691);
          v2794 = v2796;
          }
        const v2797 = stdlib.mul(v2794, v667);
        const v2798 = stdlib.add(v753, v2797);
        const v2799 = stdlib.le(v2798, v687);
        const v2800 = v2799 ? v2798 : v687;
        return;
        }
      else {
        const v2801 = stdlib.le(v679, v690);
        const v2802 = v2801 ? v679 : v690;
        let v2803;
        const v2804 = stdlib.ge(v691, v2802);
        if (v2804) {
          v2803 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v2805 = stdlib.sub(v2802, v691);
          v2803 = v2805;
          }
        const v2806 = stdlib.mul(v2803, v667);
        const v2807 = stdlib.add(v753, v2806);
        const v2808 = stdlib.le(v2807, v687);
        const v2809 = v2808 ? v2807 : v687;
        return;
        }
      break;
      }
    case 'Staker_withdraw0_239': {
      const v1090 = v837[1];
      return;
      break;
      }
    }
  
  
  };
export async function Staker_withdraw(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Staker_withdraw expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Staker_withdraw expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Null;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Data({
    None: ctc0,
    Some: ctc1
    });
  const ctc3 = stdlib.T_Address;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Struct([['rewardToken', ctc4], ['stakeToken', ctc4], ['rewardsPerBlock', ctc1], ['duration', ctc1]]);
  const ctc6 = stdlib.T_Bool;
  const ctc7 = stdlib.T_Tuple([ctc1]);
  const ctc8 = stdlib.T_Tuple([]);
  const ctc9 = stdlib.T_Data({
    Staker_harvest0_239: ctc8,
    Staker_stake0_239: ctc7,
    Staker_withdraw0_239: ctc7
    });
  const ctc10 = stdlib.T_Struct([['newUserStaked', ctc1], ['newEveryoneStaked', ctc1]]);
  
  const map0_ctc = ctc2;
  const map0 = stdlib.newMap({
    ctc: ctc,
    idx: 0,
    isAPI: true,
    ty: map0_ctc
    });
  
  const map1_ctc = ctc2;
  const map1 = stdlib.newMap({
    ctc: ctc,
    idx: 1,
    isAPI: true,
    ty: map1_ctc
    });
  
  
  const [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 6), [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6, ctc1]);
  const v787 = ctc.selfAddress();
  const v789 = stdlib.protect(ctc7, await interact.in(), {
    at: './index.rsh:1:23:application',
    fs: ['at ./index.rsh:154:7:application call to [unknown function] (defined at: ./index.rsh:154:7:function exp)', 'at ./index.rsh:90:19:application call to "runStaker_withdraw0_239" (defined at: ./index.rsh:153:9:function exp)', 'at ./index.rsh:90:19:application call to [unknown function] (defined at: ./index.rsh:90:19:function exp)'],
    msg: 'in',
    who: 'Staker_withdraw'
    });
  const v790 = v789[stdlib.checkedBigNumberify('./index.rsh:153:9:spread', stdlib.UInt_max, 0)];
  const v791 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v787), null);
  const v792 = stdlib.fromSome(v791, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
  const v793 = stdlib.le(v790, v792);
  stdlib.assert(v793, {
    at: './index.rsh:154:23:application',
    fs: ['at ./index.rsh:154:7:application call to [unknown function] (defined at: ./index.rsh:154:14:function exp)', 'at ./index.rsh:154:7:application call to [unknown function] (defined at: ./index.rsh:154:7:function exp)', 'at ./index.rsh:90:19:application call to "runStaker_withdraw0_239" (defined at: ./index.rsh:153:9:function exp)', 'at ./index.rsh:90:19:application call to [unknown function] (defined at: ./index.rsh:90:19:function exp)'],
    msg: null,
    who: 'Staker_withdraw'
    });
  const v795 = ['Staker_withdraw0_239', v789];
  
  const txn1 = await (ctc.sendrecv({
    args: [v658, v659, v660, v661, v667, v679, v686, v687, v688, v689, v690, v691, v696, v697, v698, v746, v748, v753, v795],
    evt_cnt: 1,
    funcNum: 4,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc9],
    pay: [stdlib.checkedBigNumberify('./index.rsh:155:16:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./index.rsh:155:20:decimal', stdlib.UInt_max, 0), v661]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      stdlib.simMapDupe(sim_r, 0, map0);
      stdlib.simMapDupe(sim_r, 1, map1);
      
      const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn1;
      
      switch (v837[0]) {
        case 'Staker_harvest0_239': {
          const v840 = v837[1];
          
          break;
          }
        case 'Staker_stake0_239': {
          const v965 = v837[1];
          
          break;
          }
        case 'Staker_withdraw0_239': {
          const v1090 = v837[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v661
            });
          undefined;
          const v1187 = v1090[stdlib.checkedBigNumberify('./index.rsh:153:9:spread', stdlib.UInt_max, 0)];
          const v1188 = stdlib.protect(map0_ctc, await stdlib.simMapRef(sim_r, 0, v836), null);
          const v1189 = stdlib.fromSome(v1188, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
          const v1191 = stdlib.le(v1187, v1189);
          stdlib.assert(v1191, {
            at: './index.rsh:159:16:application',
            fs: ['at ./index.rsh:156:7:application call to [unknown function] (defined at: ./index.rsh:156:7:function exp)'],
            msg: null,
            who: 'Staker_withdraw'
            });
          const v1195 = stdlib.sub(v698, v1187);
          sim_r.txns.push({
            amt: v1187,
            kind: 'from',
            to: v836,
            tok: v661
            });
          const v1196 = stdlib.sub(v689, v1187);
          const v1197 = stdlib.sub(v1189, v1187);
          await stdlib.simMapSet(sim_r, 0, v836, v1197);
          const v1198 = stdlib.protect(map1_ctc, await stdlib.simMapRef(sim_r, 1, v836), null);
          const v1199 = stdlib.fromSome(v1198, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
          let v1200;
          const v1201 = stdlib.eq(v1196, stdlib.checkedBigNumberify('./index.rsh:167:36:decimal', stdlib.UInt_max, 0));
          if (v1201) {
            v1200 = v753;
            }
          else {
            const v1202 = stdlib.mul(v753, v1187);
            const v1203 = stdlib.div(v1202, v1196);
            v1200 = v1203;
            }
          let v1204;
          const v1205 = stdlib.ge(v1200, v1199);
          if (v1205) {
            v1204 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
            }
          else {
            const v1206 = stdlib.sub(v1199, v1200);
            v1204 = v1206;
            }
          await stdlib.simMapSet(sim_r, 1, v836, v1204);
          const v1208 = {
            newEveryoneStaked: v1196,
            newUserStaked: v1197
            };
          const v1209 = await txn1.getOutput('Staker_withdraw', 'v1208', ctc10, v1208);
          
          const v2940 = v753;
          const v2941 = v687;
          const v2942 = v691;
          const v2943 = v1196;
          const v2944 = v838;
          const v2945 = v690;
          const v2946 = v696;
          const v2947 = v697;
          const v2948 = v1195;
          const v2950 = stdlib.le(v690, v679);
          const v2951 = v1201 ? v2950 : true;
          if (v2951) {
            const v2952 = stdlib.le(v679, v690);
            const v2953 = v2952 ? v679 : v690;
            let v2954;
            const v2955 = stdlib.ge(v691, v2953);
            if (v2955) {
              v2954 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
              }
            else {
              const v2956 = stdlib.sub(v2953, v691);
              v2954 = v2956;
              }
            const v2957 = stdlib.mul(v2954, v667);
            const v2958 = stdlib.add(v753, v2957);
            const v2959 = stdlib.le(v2958, v687);
            const v2960 = v2959 ? v2958 : v687;
            sim_r.isHalt = false;
            }
          else {
            const v2961 = stdlib.le(v679, v690);
            const v2962 = v2961 ? v679 : v690;
            let v2963;
            const v2964 = stdlib.ge(v691, v2962);
            if (v2964) {
              v2963 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
              }
            else {
              const v2965 = stdlib.sub(v2962, v691);
              v2963 = v2965;
              }
            const v2966 = stdlib.mul(v2963, v667);
            const v2967 = stdlib.add(v753, v2966);
            const v2968 = stdlib.le(v2967, v687);
            const v2969 = v2968 ? v2967 : v687;
            sim_r.isHalt = false;
            }
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc3, ctc5, ctc4, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6, ctc1, ctc9],
    waitIfNotPresent: false
    }));
  const {data: [v837], secs: v839, time: v838, didSend: v402, from: v836 } = txn1;
  switch (v837[0]) {
    case 'Staker_harvest0_239': {
      const v840 = v837[1];
      return;
      break;
      }
    case 'Staker_stake0_239': {
      const v965 = v837[1];
      return;
      break;
      }
    case 'Staker_withdraw0_239': {
      const v1090 = v837[1];
      ;
      ;
      undefined;
      const v1187 = v1090[stdlib.checkedBigNumberify('./index.rsh:153:9:spread', stdlib.UInt_max, 0)];
      const v1188 = stdlib.protect(map0_ctc, await stdlib.mapRef(map0, v836), null);
      const v1189 = stdlib.fromSome(v1188, stdlib.checkedBigNumberify('./index.rsh:82:57:decimal', stdlib.UInt_max, 0));
      const v1191 = stdlib.le(v1187, v1189);
      stdlib.assert(v1191, {
        at: './index.rsh:159:16:application',
        fs: ['at ./index.rsh:156:7:application call to [unknown function] (defined at: ./index.rsh:156:7:function exp)'],
        msg: null,
        who: 'Staker_withdraw'
        });
      const v1195 = stdlib.sub(v698, v1187);
      ;
      const v1196 = stdlib.sub(v689, v1187);
      const v1197 = stdlib.sub(v1189, v1187);
      await stdlib.mapSet(map0, v836, v1197);
      const v1198 = stdlib.protect(map1_ctc, await stdlib.mapRef(map1, v836), null);
      const v1199 = stdlib.fromSome(v1198, stdlib.checkedBigNumberify('./index.rsh:83:67:decimal', stdlib.UInt_max, 0));
      let v1200;
      const v1201 = stdlib.eq(v1196, stdlib.checkedBigNumberify('./index.rsh:167:36:decimal', stdlib.UInt_max, 0));
      if (v1201) {
        v1200 = v753;
        }
      else {
        const v1202 = stdlib.mul(v753, v1187);
        const v1203 = stdlib.div(v1202, v1196);
        v1200 = v1203;
        }
      let v1204;
      const v1205 = stdlib.ge(v1200, v1199);
      if (v1205) {
        v1204 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
        }
      else {
        const v1206 = stdlib.sub(v1199, v1200);
        v1204 = v1206;
        }
      await stdlib.mapSet(map1, v836, v1204);
      const v1208 = {
        newEveryoneStaked: v1196,
        newUserStaked: v1197
        };
      const v1209 = await txn1.getOutput('Staker_withdraw', 'v1208', ctc10, v1208);
      if (v402) {
        stdlib.protect(ctc0, await interact.out(v1090, v1209), {
          at: './index.rsh:153:10:application',
          fs: ['at ./index.rsh:153:10:application call to [unknown function] (defined at: ./index.rsh:153:10:function exp)', 'at ./index.rsh:179:10:application call to "k" (defined at: ./index.rsh:156:7:function exp)', 'at ./index.rsh:156:7:application call to [unknown function] (defined at: ./index.rsh:156:7:function exp)'],
          msg: 'out',
          who: 'Staker_withdraw'
          });
        }
      else {
        }
      
      const v2940 = v753;
      const v2941 = v687;
      const v2942 = v691;
      const v2943 = v1196;
      const v2944 = v838;
      const v2945 = v690;
      const v2946 = v696;
      const v2947 = v697;
      const v2948 = v1195;
      const v2950 = stdlib.le(v690, v679);
      const v2951 = v1201 ? v2950 : true;
      if (v2951) {
        const v2952 = stdlib.le(v679, v690);
        const v2953 = v2952 ? v679 : v690;
        let v2954;
        const v2955 = stdlib.ge(v691, v2953);
        if (v2955) {
          v2954 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v2956 = stdlib.sub(v2953, v691);
          v2954 = v2956;
          }
        const v2957 = stdlib.mul(v2954, v667);
        const v2958 = stdlib.add(v753, v2957);
        const v2959 = stdlib.le(v2958, v687);
        const v2960 = v2959 ? v2958 : v687;
        return;
        }
      else {
        const v2961 = stdlib.le(v679, v690);
        const v2962 = v2961 ? v679 : v690;
        let v2963;
        const v2964 = stdlib.ge(v691, v2962);
        if (v2964) {
          v2963 = stdlib.checkedBigNumberify('./index.rsh:22:24:decimal', stdlib.UInt_max, 0);
          }
        else {
          const v2965 = stdlib.sub(v2962, v691);
          v2963 = v2965;
          }
        const v2966 = stdlib.mul(v2963, v667);
        const v2967 = stdlib.add(v753, v2966);
        const v2968 = stdlib.le(v2967, v687);
        const v2969 = v2968 ? v2967 : v687;
        return;
        }
      break;
      }
    }
  
  
  };
const _ALGO = {
  ABI: {
    impure: [`Any_halt()byte[0]`, `Staker_harvest()(uint64,uint64)`, `Staker_stake(uint64)(uint64,uint64)`, `Staker_withdraw(uint64)(uint64,uint64)`],
    pure: [`end()uint64`, `opts()(uint64,uint64,uint64,uint64)`, `remainingRewards()uint64`, `rewardsAvailableAt(address,uint64)uint64`, `staked(address)uint64`, `totalStaked()uint64`],
    sigs: [`Any_halt()byte[0]`, `Staker_harvest()(uint64,uint64)`, `Staker_stake(uint64)(uint64,uint64)`, `Staker_withdraw(uint64)(uint64,uint64)`, `end()uint64`, `opts()(uint64,uint64,uint64,uint64)`, `remainingRewards()uint64`, `rewardsAvailableAt(address,uint64)uint64`, `staked(address)uint64`, `totalStaked()uint64`]
    },
  appApproval: `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`,
  appClear: `BQ==`,
  extraPages: 1,
  mapDataKeys: 1,
  mapDataSize: 18,
  stateKeys: 2,
  stateSize: 185,
  unsupported: [],
  version: 9,
  warnings: [`This program was compiled with trustworthy maps, but maps are not trustworthy on Algorand, because they are represented with local state. A user can delete their local state at any time, by sending a ClearState transaction. The only way to use local state properly on Algorand is to ensure that a user doing this can only 'hurt' themselves and not the entire system.`]
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "address payable",
                    "name": "rewardToken",
                    "type": "address"
                  },
                  {
                    "internalType": "address payable",
                    "name": "stakeToken",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "rewardsPerBlock",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "duration",
                    "type": "uint256"
                  }
                ],
                "internalType": "struct T1",
                "name": "v659",
                "type": "tuple"
              },
              {
                "internalType": "address payable",
                "name": "v660",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v661",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "address payable",
                    "name": "rewardToken",
                    "type": "address"
                  },
                  {
                    "internalType": "address payable",
                    "name": "stakeToken",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "rewardsPerBlock",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "duration",
                    "type": "uint256"
                  }
                ],
                "internalType": "struct T1",
                "name": "v659",
                "type": "tuple"
              },
              {
                "internalType": "address payable",
                "name": "v660",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v661",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T11",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T13",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Any_halt0_555",
                    "type": "bool"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Deployer0_555",
                    "type": "bool"
                  }
                ],
                "internalType": "struct T13",
                "name": "v1265",
                "type": "tuple"
              }
            ],
            "internalType": "struct T14",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T15",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e3",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T17",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Staker_harvest0_239",
                    "type": "bool"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T16",
                    "name": "_Staker_stake0_239",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T16",
                    "name": "_Staker_withdraw0_239",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T17",
                "name": "v837",
                "type": "tuple"
              }
            ],
            "internalType": "struct T20",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T21",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "newUserStaked",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "newEveryoneStaked",
            "type": "uint256"
          }
        ],
        "indexed": false,
        "internalType": "struct T19",
        "name": "v0",
        "type": "tuple"
      }
    ],
    "name": "_reach_oe_v1054",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "newUserStaked",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "newEveryoneStaked",
            "type": "uint256"
          }
        ],
        "indexed": false,
        "internalType": "struct T19",
        "name": "v0",
        "type": "tuple"
      }
    ],
    "name": "_reach_oe_v1208",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1276",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "userReceived",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalRemaining",
            "type": "uint256"
          }
        ],
        "indexed": false,
        "internalType": "struct T18",
        "name": "v0",
        "type": "tuple"
      }
    ],
    "name": "_reach_oe_v910",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Any_halt",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Staker_harvest",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "userReceived",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "totalRemaining",
            "type": "uint256"
          }
        ],
        "internalType": "struct T18",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Staker_stake",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "newUserStaked",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "newEveryoneStaked",
            "type": "uint256"
          }
        ],
        "internalType": "struct T19",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Staker_withdraw",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "newUserStaked",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "newEveryoneStaked",
            "type": "uint256"
          }
        ],
        "internalType": "struct T19",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "addr",
        "type": "address"
      }
    ],
    "name": "_reachMap0Ref",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum _enum_T0",
            "name": "which",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "_None",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "_Some",
            "type": "uint256"
          }
        ],
        "internalType": "struct T0",
        "name": "res",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "addr",
        "type": "address"
      }
    ],
    "name": "_reachMap1Ref",
    "outputs": [
      {
        "components": [
          {
            "internalType": "enum _enum_T0",
            "name": "which",
            "type": "uint8"
          },
          {
            "internalType": "bool",
            "name": "_None",
            "type": "bool"
          },
          {
            "internalType": "uint256",
            "name": "_Some",
            "type": "uint256"
          }
        ],
        "internalType": "struct T0",
        "name": "res",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T11",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T13",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Any_halt0_555",
                    "type": "bool"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Deployer0_555",
                    "type": "bool"
                  }
                ],
                "internalType": "struct T13",
                "name": "v1265",
                "type": "tuple"
              }
            ],
            "internalType": "struct T14",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T15",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m3",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T17",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Staker_harvest0_239",
                    "type": "bool"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T16",
                    "name": "_Staker_stake0_239",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T16",
                    "name": "_Staker_withdraw0_239",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T17",
                "name": "v837",
                "type": "tuple"
              }
            ],
            "internalType": "struct T20",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T21",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "end",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "opts",
    "outputs": [
      {
        "components": [
          {
            "internalType": "address payable",
            "name": "rewardToken",
            "type": "address"
          },
          {
            "internalType": "address payable",
            "name": "stakeToken",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "rewardsPerBlock",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "duration",
            "type": "uint256"
          }
        ],
        "internalType": "struct T1",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "remainingRewards",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "v3008",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "v3009",
        "type": "uint256"
      }
    ],
    "name": "rewardsAvailableAt",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "v3012",
        "type": "address"
      }
    ],
    "name": "staked",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalStaked",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 17343,
  Which: `oD`,
  version: 6,
  views: {
    end: `end`,
    opts: `opts`,
    remainingRewards: `remainingRewards`,
    rewardsAvailableAt: `rewardsAvailableAt`,
    staked: `staked`,
    totalStaked: `totalStaked`
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Any_halt": Any_halt,
  "Deployer": Deployer,
  "Staker_harvest": Staker_harvest,
  "Staker_stake": Staker_stake,
  "Staker_withdraw": Staker_withdraw
  };
export const _APIs = {
  Any: {
    halt: Any_halt
    },
  Staker: {
    harvest: Staker_harvest,
    stake: Staker_stake,
    withdraw: Staker_withdraw
    }
  };
